import { AssessmentStatus } from "api/generated/schemas/assessmentStatus";
import { infoIcon, toClassicIcon } from "common/defaultIcons";

export const ASSESSMENT_STATUS_BADGE_COLOR: Record<AssessmentStatus, string> = {
  [AssessmentStatus.not_submitted]: "portfolio-concept",
  [AssessmentStatus.pending_review]: "portfolio-assessment-pending-review",
  [AssessmentStatus.changes_requested]: "negative",
  [AssessmentStatus.graded]: "info",
  [AssessmentStatus.graded_with_retry]: "positive",
};

export const ASSESSMENT_STATUS_LABEL: Record<AssessmentStatus, string> = {
  [AssessmentStatus.not_submitted]: "Niet ingeleverd",
  [AssessmentStatus.pending_review]: "Wacht op beoordeling",
  [AssessmentStatus.changes_requested]: "Herkansen",
  [AssessmentStatus.graded]: "Beoordeeld",
  [AssessmentStatus.graded_with_retry]: "Voldaan",
};

/**
 * Label of the student's edit action once the teacher allowed a retry.
 * A "voldaan" task left open is adjusted, not retaken.
 */
export const ASSESSMENT_STATUS_CTA_LABEL: Record<
  | typeof AssessmentStatus.changes_requested
  | typeof AssessmentStatus.graded_with_retry,
  string
> = {
  [AssessmentStatus.changes_requested]: "Taak herkansen",
  [AssessmentStatus.graded_with_retry]: "Taak aanpassen",
};

export const ASSESSMENT_STATUS_BAR_LABEL: Record<
  | typeof AssessmentStatus.pending_review
  | typeof AssessmentStatus.changes_requested
  | typeof AssessmentStatus.graded_with_retry,
  string
> = {
  [AssessmentStatus.pending_review]: "Ingeleverd op: {submittedAt}",
  [AssessmentStatus.changes_requested]: "Je moet deze taak herkansen",
  [AssessmentStatus.graded_with_retry]:
    "Voldaan — je mag de taak nog aanpassen",
};

export const ASSESSMENT_STATUS_BAR_ICON: Record<
  | typeof AssessmentStatus.pending_review
  | typeof AssessmentStatus.changes_requested
  | typeof AssessmentStatus.graded_with_retry,
  string
> = {
  [AssessmentStatus.pending_review]: toClassicIcon(infoIcon),
  [AssessmentStatus.changes_requested]: toClassicIcon(infoIcon),
  [AssessmentStatus.graded_with_retry]: toClassicIcon(
    "fa-check-circle",
    "solid",
  ),
};

export const ASSESSMENT_STATUS_BAR_ICON_COLOR: Record<
  | typeof AssessmentStatus.pending_review
  | typeof AssessmentStatus.changes_requested
  | typeof AssessmentStatus.graded_with_retry,
  string
> = {
  [AssessmentStatus.pending_review]: "info",
  [AssessmentStatus.changes_requested]: "info",
  [AssessmentStatus.graded_with_retry]: "positive",
};
